<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card>
            <div slot="header">
              <h3 class="card-title mb-0">{{ $t("monthlyActiveReport.cardTitle") }}</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row class="grid-form">
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId" />
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">{{ $t('monthlyActiveReport.subscriptionType') }}</label>
                <multiselect v-model="selectedMonthlyType"
                  :placeholder="$t('monthlyActiveReport.subscriptionTypePlaceholder')" label="name" track-by="code"
                  :options="showMonthlyTypes" :multiple="true" :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">{{ $t('monthlyActiveReport.validity') }}</label>
                <multiselect v-model="selectedTerm" :placeholder="$t('monthlyActiveReport.validityPlaceholder')"
                  label="name" track-by="id" :options="terms" :multiple="false" :taggable="true" :max-height="150">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">{{ $t('monthlyActiveReport.nameOrId') }}</label>
                <vs-input type="Text" v-model="query" class="w-100 " />
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">{{ $t('monthlyActiveReport.monthlyPlate') }}</label>
                <vs-input type="Text" v-model="monthlyPlate" class="w-100 " />
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">{{ $t('monthlyActiveReport.slot') }}</label>
                <multiselect v-model="selectedSlots"
                  :placeholder="$t('monthlyActiveReport.subscriptionTypePlaceholder')" label="name" track-by="code"
                  :options="slotsList" :multiple="true" :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
            </vs-row>
            <hr class="custom-hr" />
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button @click="listMonthlyActive()">{{ $t('monthlyActiveReport.search') }}</vs-button>
                <vs-button color="gray" @click="clearForm()">{{ $t('monthlyActiveReport.clean') }}</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button class="btnx" type="filled" color="danger" @click="download()">
                      <i class="ti-upload mr-2"></i>{{ $t('monthlyActiveReport.export') }}
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                          :value="document.id" :key="document.id" :id="document.id" @click="formatType = document.id">{{
                            document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <vs-card>
            <h3 class="card-title d-flex">
              {{ $t('monthlyActiveReport.tableTitle') }}
            </h3>
            <div class="border" style="max-height: 43em;
              overflow-y: auto;">
              <vs-table :data="tableData">
                <template slot="thead">
                  <vs-th>{{ $t('monthlyActiveReport.tableColId') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColName') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColPlate') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColNumOrId') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColMontlyName') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColslot') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColstartDate') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColendDate') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColsubscriptionType') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColvehicleType') }}</vs-th>
                  <vs-th>{{ $t('monthlyActiveReport.tableColmonthlyStatus') }}</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].identification">
                      {{ data[indextr].identification }}
                    </vs-td>
                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>
                    <vs-td :data="data[indextr].plate">
                      {{ data[indextr].plate }}
                    </vs-td>
                    <vs-td :data="data[indextr].cardId">
                      {{ data[indextr].cardId }}
                    </vs-td>
                    <vs-td :data="data[indextr].serviceType">
                      {{ data[indextr].serviceType }}
                    </vs-td>
                    <vs-td :data="data[indextr].slotTitle">
                      {{ data[indextr].slotTitle }}
                    </vs-td>
                    <vs-td :data="data[indextr].initialDate">
                      {{ data[indextr].initialDate }}
                    </vs-td>
                    <vs-td :data="data[indextr].finalDate">
                      {{ data[indextr].finalDate }}
                    </vs-td>
                    <vs-td :data="data[indextr].incomeType">
                      {{ data[indextr].incomeType }}
                    </vs-td>
                    <vs-td :data="data[indextr].vehicleType">
                      {{ data[indextr].vehicleType }}
                    </vs-td>
                    <vs-td :data="data[indextr].payStatus">
                      {{ data[indextr].payStatus }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-pagination :total="Math.ceil(total / perPage)" :per-page="perPage" v-model="page" />
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import CompanySelector from "../../../../components/Shared/CompanySelector";
import { ROUTES } from "@/global/api_routes";
import Multiselect from "vue-multiselect";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import IncomeSpecialEndpoints from "@/endpoints/income/IncomeSpecialEndpoints";
import SlotEndpoint from "@/endpoints/core/SlotEndpoint";
import toast from "@/global/ToastConfig";

export default {
  name: "monthly_active_report",
  components: {
    CompanySelector,
    Multiselect
  },

  data: () => ({
    tableData: [],
    companyId: null,
    query: null,
    monthlyPlate: null,
    formatType: 'xlsx',
    isLoading: false,
    incomeType: null,
    selectedMonthlyType: [],
    showMonthlyTypes: [],
    documents: [
      { name: "Excel", id: "xlsx" },
      { name: "Pdf", id: "pdf" },
    ],
    terms: [
      { name: "Vencido", id: "EXPIRED" },
      { name: "Vigente", id: "CURRENT" },
    ],
    selectedSlots: [],
    slotsList: [],
    selectedTerm: null,
    allTerms: "ALL",
    page: 1,
    perPage: 50,
    total: 0,
    showTable: false,
  }),
  mounted() {
    this.getMonthlyType();
  },
  watch: {
    companyId() {
      this.tableData = [];
      this.page = 1;
      this.selectedMonthlyType = [];
      this.selectedTerm = null;
      this.showTable = false;
      this.getSlotList();
    },
    monthlyPlate() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    query() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    selectedTerm() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    selectedMonthlyType() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    page() {
      this.listMonthlyActive();
    },

  },
  methods: {
    /**
     * Método que limpia el formulario inicial
     */
    clearForm() {
      this.companyId = null;
      this.formatType = 'xlsx';
      this.query = null;
      this.incomeType = null;
      this.tableData = [];
      this.selectedMonthlyType = [];
      this.page = 1;
      this.showTable = false;
      this.selectedTerm = null;
      this.monthlyPlate = null;
      this.query = null;
    },
    /**
     * Metodo que asigna los parametros para descarga y previsualizacion del reporte
     * @returns {{companyId: null, monthlyPlate: null, incomeType: string, query: null, page: number, type: string, paymentStatus: (string|*)}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        query: this.query,
        incomeType: this.getIncomeType(),
        monthlyPlate: this.monthlyPlate,
        slots: Array.isArray(this.selectedSlots) ? this.selectedSlots.map(item => item.code).join(',') : '',
        paymentStatus: this.getValidateTerms(),
        page: this.page - 1,
        type: this.formatType
      };
    },
    /**
     * metodo que valida si seleccionaron un estado de vigencia o si no que tenga encuenta todos
     * @returns {string|*}
     */
    getValidateTerms() {
      return this.selectedTerm === null
        ? this.allTerms
        : this.selectedTerm.id
    },
    /**
     * metodo que valida si seleccionaron un tipo de mensual o si no que tenga encuenta todos
     * @returns {string}
     */
    getIncomeType() {
      return this.selectedMonthlyType.length === 0
        ? this.showMonthlyTypes.map(item => item.code).join(",")
        : this.selectedMonthlyType.map(item => item.code).join(",");
    },
    /**
     * Consulta los slots de la compañía seleccionada
     */
    getSlotList() {
      SlotEndpoint.listByCompany(this.companyId)
        .then(data => {
          const list = Array.isArray(data)
            ? data.map(item => ({ name: item.title, code: item.code }))
            : [];

          console.log('LIST:', list)
          this.slotsList = list;
        })
    },
    /**
     * Método que obtiene los tipos de mensualidad
     */
    getMonthlyType() {
      IncomeSpecialEndpoints.listIncomeSpecialTypes()
        .then(data => {
          if (data.code <= 0) {
            toast.error(data.message);
            return;
          }
          toast.ok(data.message);
          data.info.forEach((monthly) => {
            const unity = {
              name: monthly.title,
              code: monthly.code,
            };
            this.showMonthlyTypes.push(unity);
          });
        })
    },
    /**
     * Metodo que valida mis parametros en la interfaz grafica
     * para no hecer peticiones erroneas al servidor
     * @returns {Promise<void>}
     */
    async validateForm() {
      if (!this.companyId) {
        throw new Error("Seleccione una compañia");
      }
    },
    /**
     * Metodo de descarga del reporte por medio de una promesa
     * @returns {Promise<void>}
     */
    async download() {
      try {
        await this.validateForm();
        if (!this.formatType) {
          throw new Error("Seleccione tipo de formato que desea generar");
        }
        this.isLoading = true;
        const params = this.prepareParameters();
        parkingReportsEndpoints.downloadMonthlyActive(params)
          .then(data => {
            if (data.code < 0) {
              this.isLoading = false;
              return;
            }
            this.isLoading = false;
            let a = document.createElement("a");
            const urlFile =
              process.env.VUE_APP_URL + ROUTES.GLOBAL.DOWNLOAD_FILE + data.info;
            a.href = urlFile;
            document.body.appendChild(a);
            console.log(urlFile);
            a.download = urlFile;
            a.click();
          });
      } catch (error) {
        toast.error(error);
      }
    },
    /**
     * Metodo que genera la previsualizacion de la tabla por medio de una promesa
     * @returns {Promise<void>}
     */
    async listMonthlyActive() {
      try {
        this.isLoading = true;
        const params = this.prepareParameters();
        parkingReportsEndpoints.listMonthlyActive(params)
          .then(info => {
            this.isLoading = false;
            this.tableData = info.records || [];
            this.total = info.total || 0;
            this.showTable = true;
          });
      } catch (error) {
        toast.error(error);
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.grid-form .vs-col {
  margin-bottom: 10px;
}

.grid-form .vs-input--label {
  transform: translateY(6px) !important;
}

.grid-form .vs-inputx {
  height: 42px;
}
</style>